import { CircularProgress, TableCell, TableRow, Tooltip } from '@mui/material'
import moment from 'moment'
import { PendingStatus, PendingStatusIndicator } from '@components'
import * as pendingStyles from '../../styles'
import { PendingRow } from '../../types'
import { ActionButtons } from '../actionButtons'
import * as css from './styles'
import { t } from '@lingui/core/macro'

interface Props {
  index: number
  row: PendingRow
  handleRowClick: (row: PendingRow) => void
  invalidateQueryCache: () => void
  paddingLeftFirstCell: number
  dataSourceEnabled: boolean
  showCreatedByName?: boolean
}

export const PendingTableRow = ({
  index,
  row,
  handleRowClick,
  invalidateQueryCache,
  paddingLeftFirstCell = 16,
  dataSourceEnabled = false,
  showCreatedByName = false,
}: Props) => {
  const {
    has_pending_rows,
    id,
    identifier,
    name,
    number_of_rows,
    template_name,
    type,
    updated_at,
    last_updated,
    created_by_name,
    status,
    source,
    row_count,
  } = row

  const rowStatus = status || type
  const showProcessingSpinner = has_pending_rows && rowStatus !== PendingStatus.REJECTED

  return (
    <TableRow
      css={[css.tableRow, pendingStyles.hoverable, css.hideOverflow]}
      hover
      key={`${id}-${status}`}
      onClick={() => {
        handleRowClick(row)
      }}
      tabIndex={-1}
    >
      <TableCell
        component="td"
        css={[css.tableCell, css.hideOverflow]}
        padding="normal"
        scope="row"
        style={{ paddingLeft: paddingLeftFirstCell }}
      >
        {moment(last_updated || updated_at).format('MM/DD/YY')}
      </TableCell>
      <TableCell
        component="td"
        padding="normal"
        scope="row"
        className="relative"
        data-tooltip={identifier || name}
        data-tooltip-dir={index === 0 ? 'bottom' : 'top'}
      >
        <span className="overflow-hidden whitespace-nowrap text-ellipsis max-w-[45ch] block">
          {identifier || name}
        </span>
      </TableCell>
      <TableCell
        component="td"
        padding="normal"
        scope="row"
        className="relative"
        data-tooltip={showCreatedByName ? created_by_name : template_name}
        data-tooltip-dir={index === 0 ? 'bottom' : 'top'}
      >
        <span className="overflow-hidden whitespace-nowrap text-ellipsis max-w-[45ch] block">
          {showCreatedByName ? created_by_name : template_name}
        </span>
      </TableCell>
      <TableCell
        component="td"
        scope="row"
        padding="normal"
        css={[css.tableCell, css.hideOverflow]}
      >
        <div css={css.rowCountContainer}>
          <span>{row_count || number_of_rows}</span>
          {showProcessingSpinner && (
            <Tooltip title={t`Processing rows`}>
              <CircularProgress css={css.processingSpinner} size={12} color="primary" />
            </Tooltip>
          )}
        </div>
      </TableCell>
      {dataSourceEnabled && (
        <TableCell
          component="td"
          css={[css.tableCell, css.hideOverflow]}
          padding="normal"
          scope="row"
        >
          {source}
        </TableCell>
      )}
      <TableCell component="td" scope="row" padding="normal">
        <div css={css.statusContainer}>
          <PendingStatusIndicator status={rowStatus} />
        </div>
      </TableCell>
      <ActionButtons row={row} invalidateQueryCache={invalidateQueryCache} />
    </TableRow>
  )
}
